<template>
  <div class="py-8 relative">
    <FormTemplate title="Small Business Packages">
      <template #main>
        <div class="flex flex-wrap row-wrapper">
          <div
            v-for="(bundle, index) in bundles"
            :key="index"
            :class="bundle.classes ? bundle.classes : 'flex w-full md:w-1/2 justify-center'"
          >
            <BundleBlock v-bind="bundle"></BundleBlock>
          </div>
        </div>
      </template>
    </FormTemplate>
  </div>
</template>

<script>
  import FormTemplate from "../shared/FormTemplate";
  import BundleBlock from "../shared/BundleBlock";

  export default {
    name: "SmallBusiness",
    components: {
      FormTemplate,
      BundleBlock
    },
    data() {
      return {
        bundles: [
          {
            title: "Cloud Sites + Spam Gateway",
            price: 11.0,
            description:
              "The basic, everything you need package. Web hosting and spam filtering bundled so you can get to work.",
            link: "",
            classes: "flex w-full md:w-1/2 justify-center"
          },
          {
            title: "Cloud Sites + Office 365",
            price: 14.0,
            description:
              "A generous step up from just what you need includes premier web hosting and a top-notch collaboration suite.",
            link: "",
            classes: "flex w-full md:w-1/2 justify-center"
          },
          {
            title: "Office 365 + Spam Gateway",
            price: 13.0,
            description:
              "Arguably the best collaboration suite, combined with proven reputation protection. Basically, the sweet spot.",
            link: "",
            classes: "flex w-full md:w-1/2 justify-center"
          },
          {
            title: "Office 365 + Cloud Voice",
            price: 53.0,
            description:
              "A communication platform paired practically to push your business forward without getting in the way.",
            link: "",
            classes: "flex w-full md:w-1/2 justify-center"
          },
          {
            title: "The Everything Bundle",
            price: 64.0,
            description:
              "Cloud sites, cloud voice, spam gateway, and Office 365. What else could you ask for?",
            link: "",
            classes: "flex w-full justify-center"
          }
        ]
      };
    }
  };
</script>
